import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

// Services
import { RouteParam, ServiceBase } from '../service-base';

// Modèles
import { AnalyticalDefault } from 'src/app/@shared/models/analytical/analytical-default.model';

const CLASS_NAME = 'AnalyticalDefault';
const ENDPOINT = `/analytical-defaults/`;
const ROUTES: RouteParam[] = [
    { key: 'apply', path: '{id}/apply/' },
]

@Injectable({
    providedIn: 'root'
})
export class AnalyticalDefaultService extends ServiceBase {
    constructor() {
        super(CLASS_NAME, ENDPOINT);
        this.addRoutes(ROUTES);
    }

    /** Application rétroactive du défaut aux imputations existantes non encore ventilées. */
    public applyDefault$(analyticalDefault: AnalyticalDefault): Observable<AnalyticalDefault> {
        let url = this.routes.apply.replace('{id}', analyticalDefault.id.toString());
        return this.update$(analyticalDefault, {
            url: url
        });
    }
}
